<!-- Navigation -->
<fuse-vertical-navigation
  class="dark bg-gray-900 print:hidden"
  [appearance]="'compact'"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation.compact"
  [opened]="!isScreenSmall">
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <!-- Logo -->
    <div class="mb-4 mt-3 flex h-20 items-center justify-center">
      <img class="w-10" src="assets/images/logo/logo.svg" alt="Logo image" />
    </div>
  </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
  <!-- Header -->
  <div
    class="flex-0 z-49 bg-card relative flex h-16 w-full items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none print:hidden md:px-6">
    <!-- Navigation toggle button -->
    <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'heroicons_outline:bars-3'" />
    </button>
    <!-- Components -->
    <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
      <languages />
      <fuse-fullscreen class="hidden md:block" />
      <search [appearance]="'bar'" />
      <shortcuts />
      <messages />
      <notifications />
      <button class="lg:hidden" mat-icon-button (click)="quickChat.toggle()">
        <mat-icon [svgIcon]="'heroicons_outline:chat-alt-2'" />
      </button>
      <user />
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-auto flex-col">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
    Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <router-outlet />
    }
  </div>

  <!-- Footer -->
  <div
    class="flex-0 z-49 bg-card relative flex h-14 w-full items-center justify-start border-t px-4 dark:bg-transparent print:hidden md:px-6">
    <span class="text-secondary font-medium"
      >Fuse &copy; {{ currentYear }}</span
      >
    </div>
  </div>

  <!-- Quick chat -->
  <quick-chat #quickChat="quickChat" />
